import { render, staticRenderFns } from "./AccessoryAdd.vue?vue&type=template&id=7670785e&scoped=true"
import script from "./AccessoryAdd.vue?vue&type=script&lang=js"
export * from "./AccessoryAdd.vue?vue&type=script&lang=js"
import style0 from "./AccessoryAdd.vue?vue&type=style&index=0&id=7670785e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7670785e",
  null
  
)

export default component.exports